// import React, { useState, useEffect } from "react";

// export default function MerchantSubscriptionPanel() {
//   // Extract Dynamic Merchant ID safely
//   const getDynamicMerchantId = () => {
//     try {
//       const savedDataString = localStorage.getItem("userData");
//       if (savedDataString) {
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           return parsed.merchant.user_id;
//         }
//       }
//     } catch (e) {
//       console.error("Error reading initial userData:", e);
//     }
//     return "CMV9A117EAC";
//   };

//   const MERCHANT_ID = getDynamicMerchantId();

//   // Navigation & Screen Control States
//   const [activeTab, setActiveTab] = useState("plans"); // 'plans' or 'history'
//   const [loading, setLoading] = useState(true);
  
//   // Data States
//   const [availablePlans, setAvailablePlans] = useState([]);
//   const [subscriptionHistory, setSubscriptionHistory] = useState([]);
  
//   // Checkout & Razorpay Ready States
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [isProcessing, setIsProcessing] = useState(false);

//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // 1. Fetch Available Subscription Plans
//   const fetchAvailablePlans = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("plan_name", "1 Month Plan");
//       formdata.append("amount", "199");
//       formdata.append("description", "Unlimited Scans + Analytics");
//       formdata.append("duration_months", "1");

//       const response = await fetch("https://countmyvisit.com/Apis/subscription_plans.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setAvailablePlans(data.plans || []);
//       }
//     } catch (error) {
//       console.error("Error fetching subscription plans:", error);
//     }
//   };

//   // 2. Fetch Merchant Subscription History
//   const fetchSubscriptionHistory = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("duration_months", "6");
//       formdata.append("plan_id", "3");
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/subscription_history.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setSubscriptionHistory(data.history || []);
//       }
//     } catch (error) {
//       console.error("Error fetching subscription history:", error);
//     }
//   };

//   //3. Handle Plan Activation Flow (Razorpay Ready)
// //   const handleActivatePlan = async (plan) => {
// //     setIsProcessing(true);
// //     try {
// //       // Future Razorpay Handler can be direct injected here
// //       // For now, executing the backend system confirmation
// //       const formdata = new FormData();
// //       formdata.append("duration_months", plan.duration_months);
// //       formdata.append("plan_id", plan.id);
// //       formdata.append("merchant_id", MERCHANT_ID);

// //       const response = await fetch("https://countmyvisit.com/Apis/buy_subscription.php", {
// //         method: "POST",
// //         body: formdata,
// //         redirect: "follow"
// //       });
// //       const resText = await response.text();
// //       const data = cleanAndParseJson(resText);

// //       if (data.success) {
// //         alert(`Plan Activated Successfully!\nPlan: ${data.plan_name}\nValid Till: ${data.end_date}`);
// //         setSelectedPlan(null);
// //         // Refresh data pool
// //         await fetchSubscriptionHistory();
// //         setActiveTab("history");
// //       } else {
// //         alert(data.message || "Activation Pipeline Error");
// //       }
// //     } catch (error) {
// //       console.error("Purchase processing failed:", error);
// //       alert("Payment Execution Error");
// //     } finally {
// //       setIsProcessing(false);
// //     }
// //   };


// const handleActivatePlan = async (plan) => {
//   try {

//     setIsProcessing(true);

//     const formdata = new FormData();

//     formdata.append("merchant_id", MERCHANT_ID);
//     formdata.append("plan_id", plan.id);

//     const response = await fetch(
//       "https://countmyvisit.com/Apis/create_order.php",
//       {
//         method: "POST",
//         body: formdata
//       }
//     );

//     const txt = await response.text();

//     const orderData = cleanAndParseJson(txt);

//     if (!orderData.success) {
//       alert(orderData.message);
//       return;
//     }

//     const options = {

//       key: "rzp_test_T3qnCkPeAhSP0g",

//       amount: orderData.amount,

//       currency: "INR",

//       name: "Count My Visit",

//       description: plan.plan_name,

//       order_id: orderData.order_id,

//       handler: async function (paymentResponse) {

//         const verifyData = new FormData();

//         verifyData.append(
//           "razorpay_payment_id",
//           paymentResponse.razorpay_payment_id
//         );

//         verifyData.append(
//           "razorpay_order_id",
//           paymentResponse.razorpay_order_id
//         );

//         verifyData.append(
//           "razorpay_signature",
//           paymentResponse.razorpay_signature
//         );

//         const verifyResponse = await fetch(
//           "https://countmyvisit.com/Apis/verify_payment.php",
//           {
//             method: "POST",
//             body: verifyData
//           }
//         );

//         const verifyText = await verifyResponse.text();

//         const verifyResult =
//           cleanAndParseJson(verifyText);

//         if (verifyResult.success) {

//           alert(
//             "Subscription Activated Successfully"
//           );

//           setSelectedPlan(null);

//           fetchSubscriptionHistory();

//           setActiveTab("history");

//         } else {

//           alert(
//             verifyResult.message
//           );
//         }
//       },

//       theme: {
//         color: "#ff8c42"
//       }
//     };

//     const razorpay =
//       new window.Razorpay(options);

//     razorpay.open();

//   } catch (error) {

//     console.log(error);

//     alert("Payment Failed");

//   } finally {

//     setIsProcessing(false);
//   }
// };
//   useEffect(() => {
//     const loadSubscriptionData = async () => {
//       setLoading(true);
//       await Promise.all([fetchAvailablePlans(), fetchSubscriptionHistory()]);
//       setLoading(false);
//     };
//     loadSubscriptionData();
//   }, [MERCHANT_ID]);

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <style>{`
//           .loader-container { display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100vh; background: #f8fafc; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//           .spinner { width: 44px; height: 44px; border: 3px solid rgba(255, 140, 66, 0.1); border-left-color: #ff8c42; border-radius: 50%; animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite; margin-bottom: 16px; }
//           .loader-text { font-weight: 600; font-size: 14px; color: #64748b; letter-spacing: 0.5px; }
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>
//         <div className="spinner"></div>
//         <p className="loader-text">FETCHING BILLING SCHEMATICS...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//         body { background: #f8fafc; color: #1e293b; }
//         .merchant-page { min-height: 100vh; padding: 32px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); position: relative; }
        
//         /* Premium Dynamic Navigation Bar */
//         .premium-nav {
//           display: flex; justify-content: space-between; align-items: center; background: #ffffff; padding: 16px 32px; border-radius: 20px;
//           box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05); margin-bottom: 30px; border: 1px solid rgba(255, 255, 255, 0.8);
//         }
//         .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        
//         /* Segmented Tabs Layout */
//         .tabs-container { display: flex; gap: 12px; background: #e2e8f0; padding: 6px; border-radius: 14px; margin-bottom: 30px; max-width: 400px; }
//         .tab-btn { flex: 1; padding: 10px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; color: #475569; background: transparent; }
//         .tab-btn.active { background: #ffffff; color: #0f172a; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }

//         /* Dashboard Top Info Card */
//         .top-header {
//           background: #ffffff; padding: 30px; border-radius: 24px; box-shadow: 0 10px 30px rgba(0,0,0,0.02);
//           display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; border-left: 6px solid #ff8c42;
//         }
//         .merchant-title { font-size: 28px; font-weight: 800; color: #0f172a; }
//         .merchant-sub { font-size: 14px; color: #64748b; margin-top: 4px; }
//         .merchant-logo { width: 60px; height: 60px; border-radius: 18px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 22px; font-weight: 700; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }

//         /* Plans Grid Configuration */
//         .plans-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; }
//         .plan-card { background: white; border-radius: 24px; padding: 32px; border: 1px solid #e2e8f0; position: relative; display: flex; flex-direction: column; justify-content: space-between; transition: transform 0.2s, box-shadow 0.2s; }
//         .plan-card:hover { transform: translateY(-4px); box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06); }
//         .plan-card.popular { border-color: #ff8c42; box-shadow: 0 10px 25px rgba(255, 140, 66, 0.08); }
//         .popular-badge { position: absolute; top: -12px; right: 24px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 11px; font-weight: 700; padding: 4px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px; }
        
//         .plan-name { font-size: 20px; font-weight: 800; color: #0f172a; margin-bottom: 8px; }
//         .plan-desc { color: #64748b; font-size: 14px; margin-bottom: 24px; min-height: 40px; }
//         .plan-price-box { margin-bottom: 28px; }
//         .plan-currency { font-size: 20px; font-weight: 700; color: #0f172a; vertical-align: top; margin-right: 2px; }
//         .plan-price { font-size: 42px; font-weight: 800; color: #0f172a; letter-spacing: -1px; }
//         .plan-duration { color: #64748b; font-size: 14px; font-weight: 500; }

//         .action-btn { width: 100%; height: 50px; border: none; border-radius: 14px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); }
//         .action-btn:hover { opacity: 0.95; transform: translateY(-1px); }
        
//         /* Tables Core Billing Engine */
//         .card-table-wrap { background: white; border-radius: 24px; padding: 28px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0; }
//         .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; }
//         table { width: 100%; border-collapse: collapse; min-width: 850px; text-align: left; }
//         th { background: #f8fafc; color: #475569; padding: 16px 24px; font-size: 13px; font-weight: 700; border-bottom: 2px solid #e2e8f0; text-transform: uppercase; letter-spacing: 0.5px; }
//         td { padding: 18px 24px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
//         tr:hover { background: #f8fafc; }
        
//         /* Badges Engine */
//         .badge { display: inline-block; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase; }
//         .badge-active { background: #ecfdf5; color: #047857; border: 1px solid #a7f3d0; }
//         .badge-expired { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }
        
//         /* Modal Overlay for Payment Initialization */
//         .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(8px); display: flex; justify-content: center; align-items: center; z-index: 1000; padding: 24px; }
//         .modal-card { background: white; border-radius: 24px; max-width: 440px; width: 100%; padding: 32px; border: 1px solid #e2e8f0; box-shadow: 0 20px 40px rgba(0,0,0,0.1); text-align: center; }
//         .modal-title { font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 8px; }
//         .modal-desc { color: #64748b; font-size: 14px; margin-bottom: 24px; }
        
//         .modal-btn-row { display: flex; gap: 12px; margin-top: 20px; }
//         .btn-cancel { flex: 1; height: 50px; background: #f1f5f9; border: none; border-radius: 14px; color: #475569; font-weight: 600; cursor: pointer; }
//         .btn-cancel:hover { background: #e2e8f0; color: #0f172a; }

//         .empty-placeholder { padding: 50px; text-align: center; color: #94a3b8; font-size: 15px; font-weight: 500; }
//       `}</style>

//       <div className="merchant-page">
        
//         {/* PREMIUM NAVIGATION */}
//         <nav className="premium-nav">
//           <div className="nav-brand">CountMyVisit</div>
//           <span className="badge" style={{ background: '#f1f5f9', color: '#475569', fontFamily: 'monospace' }}>MID: {MERCHANT_ID}</span>
//         </nav>

//         {/* TOP COMPONENT HEADER */}
//         <header className="top-header">
//           <div>
//             <div className="merchant-title">Subscription Management</div>
//             <div className="merchant-sub">Activate secure premium pipelines, unlock analytical tracking tools</div>
//           </div>
//           <div className="merchant-logo">S</div>
//         </header>

//         {/* NAVIGATION SEGMENTED TABS */}
//         <div className="tabs-container">
//           <button className={`tab-btn ${activeTab === "plans" ? "active" : ""}`} onClick={() => setActiveTab("plans")}>
//             Available Plans
//           </button>
//           <button className={`tab-btn ${activeTab === "history" ? "active" : ""}`} onClick={() => setActiveTab("history")}>
//             Billing History ({subscriptionHistory.length})
//           </button>
//         </div>

//         {/* WORKSPACE CONDITIONALS */}
//         {activeTab === "plans" ? (
//           <div className="plans-grid">
//             {availablePlans.map((plan) => {
//               const isSixMonth = plan.plan_name.toLowerCase().includes("6");
//               return (
//                 <div key={plan.id} className={`plan-card ${isSixMonth ? "popular" : ""}`}>
//                   {isSixMonth && <div className="popular-badge">Best Value</div>}
//                   <div>
//                     <div className="plan-name">{plan.plan_name}</div>
//                     <div className="plan-desc">{plan.description}</div>
//                     <div className="plan-price-box">
//                       <span className="plan-currency">₹</span>
//                       <span className="plan-price">{parseInt(plan.amount)}</span>
//                       <span className="plan-duration"> / {plan.duration_months} Month</span>
//                     </div>
//                   </div>
//                   <button className="action-btn" onClick={() => setSelectedPlan(plan)}>
//                     {isSixMonth ? "Upgrade to Pro" : "Renew Subscriptions"}
//                   </button>
//                 </div>
//               );
//             })}
//           </div>
//         ) : (
//           <div className="card-table-wrap">
//             <h2>Payment & Audit History</h2>
//             <p style={{ color: '#64748b', fontSize: '13.5px', marginBottom: '20px' }}>Historical active mapping loops for ledger reconciliation</p>
            
//             <div className="table-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Plan Description</th>
//                     <th>Transaction Cost</th>
//                     <th>Allocation Window</th>
//                     <th>Status Flag</th>
//                     <th>Horizon Delta</th>
//                     <th>Created At</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {subscriptionHistory.length === 0 ? (
//                     <tr>
//                       <td colSpan="6" className="empty-placeholder">No transaction logs mapped into local storage matrix.</td>
//                     </tr>
//                   ) : (
//                     subscriptionHistory.map((log) => (
//                       <tr key={log.id}>
//                         <td style={{ fontWeight: '700', color: '#0f172a' }}>{log.plan_name}</td>
//                         <td style={{ fontWeight: '600', color: '#0f172a' }}>₹{log.amount}</td>
//                         <td style={{ fontSize: '13px', color: '#475569' }}>
//                           {log.start_date} <span style={{ color: '#94a3b8' }}>to</span> {log.end_date}
//                         </td>
//                         <td>
//                           <span className={`badge ${log.status === "active" ? "badge-active" : "badge-expired"}`}>
//                             {log.status}
//                           </span>
//                         </td>
//                         <td style={{ fontWeight: '700', color: '#ff8c42', fontFamily: 'monospace' }}>
//                           {log.days_left} Days Left
//                         </td>
//                         <td style={{ color: '#94a3b8', fontSize: '13px' }}>{log.created_at}</td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {/* RAZERPAY PAYMENT CONFIRMATION GATEWAY MODAL */}
//         {selectedPlan && (
//           <div className="modal-overlay">
//             <div className="modal-card">
//               <div className="modal-title">Confirm Secure Purchase</div>
//               <div className="modal-desc">
//                 You are initiating connection parameters to sub-license the <strong>{selectedPlan.plan_name}</strong>.
//               </div>
              
//               <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '14px', marginBottom: '24px', textAlign: 'left', border: '1px solid #e2e8f0' }}>
//                 <div style={{ display: 'flex', justifyBetween: 'space-between', marginBottom: '6px', fontSize: '14px' }}>
//                   <span style={{ color: '#64748b' }}>Plan Payload:</span>
//                   <span style={{ fontWeight: '700', marginLeft: 'auto' }}>{selectedPlan.plan_name}</span>
//                 </div>
//                 <div style={{ display: 'flex', justifyBetween: 'space-between', fontSize: '15px', paddingTop: '6px', borderTop: '1px dashed #cbd5e1' }}>
//                   <span style={{ color: '#0f172a', fontWeight: '600' }}>Payable Amount:</span>
//                   <span style={{ fontWeight: '800', color: '#ff8c42', marginLeft: 'auto' }}>₹{selectedPlan.amount}</span>
//                 </div>
//               </div>

//               <div className="modal-btn-row">
//                 <button className="btn-cancel" disabled={isProcessing} onClick={() => setSelectedPlan(null)}>
//                   Abort
//                 </button>
//                 <button className="action-btn" style={{ flex: 1 }} disabled={isProcessing} onClick={() => handleActivatePlan(selectedPlan)}>
//                   {isProcessing ? "Connecting Gateway..." : "Pay with Razorpay"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";

// export default function MerchantSubscriptionPanel() {
//   // Extract Dynamic Merchant ID safely
//   const getDynamicMerchantId = () => {
//     try {
//       const savedDataString = localStorage.getItem("userData");
//       if (savedDataString) {
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           return parsed.merchant.user_id;
//         }
//       }
//     } catch (e) {
//       console.error("Error reading initial userData:", e);
//     }
//     return "CMVA1AE47572E";
//   };

//   const MERCHANT_ID = getDynamicMerchantId();

//   // Navigation & Screen Control States
//   const [activeTab, setActiveTab] = useState("plans"); // 'plans' or 'history'
//   const [loading, setLoading] = useState(true);
  
//   // Data States
//   const [availablePlans, setAvailablePlans] = useState([]);
//   const [subscriptionHistory, setSubscriptionHistory] = useState([]);
  
//   // Checkout & Razorpay Ready States
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [isProcessing, setIsProcessing] = useState(false);

//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // 1. Fetch Available Subscription Plans
//   const fetchAvailablePlans = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("plan_name", "1 Month Plan");
//       formdata.append("amount", "199");
//       formdata.append("description", "Unlimited Scans + Analytics");
//       formdata.append("duration_months", "1");

//       const response = await fetch("https://countmyvisit.com/Apis/subscription_plans.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setAvailablePlans(data.plans || []);
//       }
//     } catch (error) {
//       console.error("Error fetching subscription plans:", error);
//     }
//   };

//   // 2. Fetch Merchant Subscription History
//   const fetchSubscriptionHistory = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("duration_months", "6");
//       formdata.append("plan_id", "3");
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/subscription_history.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setSubscriptionHistory(data.history || []);
//       }
//     } catch (error) {
//       console.error("Error fetching subscription history:", error);
//     }
//   };

//   // 3. Handle Order Creation and Razorpay Initiation Lifecycle
//   const handleActivatePlan = async (plan) => {
//     try {
//       setIsProcessing(true);

//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("plan_id", plan.id);
//       formdata.append("plan_name", plan.plan_name);
//       formdata.append("amount", parseFloat(plan.amount).toFixed(0));
//       formdata.append("description", plan.description);
//       formdata.append("duration_months", plan.duration_months);

//       const response = await fetch("https://countmyvisit.com/Apis/create_order.php", {
//         method: "POST",
//         body: formdata
//       });

//       const txt = await response.text();
//       const orderData = cleanAndParseJson(txt);

//       if (!orderData.success) {
//         alert(orderData.message || "Order creation failure.");
//         setIsProcessing(false);
//         return;
//       }

//       const options = {
//         key: "rzp_test_T3qnCkPeAhSP0g",
//         amount: orderData.amount_in_paise || orderData.amount * 100,
//         currency: orderData.currency || "INR",
//         name: "Count My Visit",
//         description: plan.plan_name,
//         order_id: orderData.razorpay_order_id, // Mapped perfectly from your API response
//         handler: async function (paymentResponse) {
//           try {
//             const verifyData = new FormData();
//             verifyData.append("razorpay_payment_id", paymentResponse.razorpay_payment_id);
//             verifyData.append("razorpay_order_id", paymentResponse.razorpay_order_id);
//             verifyData.append("razorpay_signature", paymentResponse.razorpay_signature);
//             verifyData.append("merchant_id", MERCHANT_ID);

//             const verifyResponse = await fetch("https://countmyvisit.com/Apis/verify_payment.php", {
//               method: "POST",
//               body: verifyData
//             });

//             const verifyText = await verifyResponse.text();
//             const verifyResult = cleanAndParseJson(verifyText);

//             if (verifyResult.success) {
//               alert("Subscription Activated Successfully!");
//               setSelectedPlan(null);
//               fetchSubscriptionHistory();
//               setActiveTab("history");
//             } else {
//               alert(verifyResult.message || "Payment verification failed.");
//             }
//           } catch (err) {
//             console.error("Verification system error:", err);
//             alert("Error running confirmation system.");
//           }
//         },
//         theme: {
//           color: "#ff8c42"
//         },
//         modal: {
//           ondismiss: function () {
//             setIsProcessing(false);
//           }
//         }
//       };

//       const razorpay = new window.Razorpay(options);
//       razorpay.open();

//     } catch (error) {
//       console.error("Order processing loop failed:", error);
//       alert("Payment Framework Initialization Failure");
//       setIsProcessing(false);
//     }
//   };

//   useEffect(() => {
//     const loadSubscriptionData = async () => {
//       setLoading(true);
//       await Promise.all([fetchAvailablePlans(), fetchSubscriptionHistory()]);
//       setLoading(false);
//     };
//     loadSubscriptionData();
//   }, [MERCHANT_ID]);

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <style>{`
//           .loader-container { display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100vh; background: #f8fafc; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//           .spinner { width: 44px; height: 44px; border: 3px solid rgba(255, 140, 66, 0.1); border-left-color: #ff8c42; border-radius: 50%; animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite; margin-bottom: 16px; }
//           .loader-text { font-weight: 600; font-size: 14px; color: #64748b; letter-spacing: 0.5px; }
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>
//         <div className="spinner"></div>
//         <p className="loader-text">FETCHING BILLING SCHEMATICS...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//         body { background: #f8fafc; color: #1e293b; }
//         .merchant-page { min-height: 100vh; padding: 32px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); position: relative; }
        
//         /* Premium Dynamic Navigation Bar */
//         .premium-nav {
//           display: flex; justify-content: space-between; align-items: center; background: #ffffff; padding: 16px 32px; border-radius: 20px;
//           box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05); margin-bottom: 30px; border: 1px solid rgba(255, 255, 255, 0.8);
//         }
//         .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        
//         /* Segmented Tabs Layout */
//         .tabs-container { display: flex; gap: 12px; background: #e2e8f0; padding: 6px; border-radius: 14px; margin-bottom: 30px; max-width: 400px; }
//         .tab-btn { flex: 1; padding: 10px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; color: #475569; background: transparent; }
//         .tab-btn.active { background: #ffffff; color: #0f172a; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }

//         /* Dashboard Top Info Card */
//         .top-header {
//           background: #ffffff; padding: 30px; border-radius: 24px; box-shadow: 0 10px 30px rgba(0,0,0,0.02);
//           display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; border-left: 6px solid #ff8c42;
//         }
//         .merchant-title { font-size: 28px; font-weight: 800; color: #0f172a; }
//         .merchant-sub { font-size: 14px; color: #64748b; margin-top: 4px; }
//         .merchant-logo { width: 60px; height: 60px; border-radius: 18px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 22px; font-weight: 700; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }

//         /* Plans Grid Configuration */
//         .plans-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; }
//         .plan-card { background: white; border-radius: 24px; padding: 32px; border: 1px solid #e2e8f0; position: relative; display: flex; flex-direction: column; justify-content: space-between; transition: transform 0.2s, box-shadow 0.2s; }
//         .plan-card:hover { transform: translateY(-4px); box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06); }
//         .plan-card.popular { border-color: #ff8c42; box-shadow: 0 10px 25px rgba(255, 140, 66, 0.08); }
//         .popular-badge { position: absolute; top: -12px; right: 24px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 11px; font-weight: 700; padding: 4px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px; }
        
//         .plan-name { font-size: 20px; font-weight: 800; color: #0f172a; margin-bottom: 8px; }
//         .plan-desc { color: #64748b; font-size: 14px; margin-bottom: 24px; min-height: 40px; }
//         .plan-price-box { margin-bottom: 28px; }
//         .plan-currency { font-size: 20px; font-weight: 700; color: #0f172a; vertical-align: top; margin-right: 2px; }
//         .plan-price { font-size: 42px; font-weight: 800; color: #0f172a; letter-spacing: -1px; }
//         .plan-duration { color: #64748b; font-size: 14px; font-weight: 500; }

//         .action-btn { width: 100%; height: 50px; border: none; border-radius: 14px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); }
//         .action-btn:hover { opacity: 0.95; transform: translateY(-1px); }
//         .action-btn:disabled { background: #cbd5e1; color: #94a3b8; cursor: not-allowed; box-shadow: none; }
        
//         /* Tables Core Billing Engine */
//         .card-table-wrap { background: white; border-radius: 24px; padding: 28px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0; }
//         .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; }
//         table { width: 100%; border-collapse: collapse; min-width: 850px; text-align: left; }
//         th { background: #f8fafc; color: #475569; padding: 16px 24px; font-size: 13px; font-weight: 700; border-bottom: 2px solid #e2e8f0; text-transform: uppercase; letter-spacing: 0.5px; }
//         td { padding: 18px 24px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
//         tr:hover { background: #f8fafc; }
        
//         /* Badges Engine */
//         .badge { display: inline-block; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase; }
//         .badge-active { background: #ecfdf5; color: #047857; border: 1px solid #a7f3d0; }
//         .badge-expired { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }
        
//         /* Modal Overlay for Payment Initialization */
//         .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(8px); display: flex; justify-content: center; align-items: center; z-index: 1000; padding: 24px; }
//         .modal-card { background: white; border-radius: 24px; max-width: 440px; width: 100%; padding: 32px; border: 1px solid #e2e8f0; box-shadow: 0 20px 40px rgba(0,0,0,0.1); text-align: center; }
//         .modal-title { font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 8px; }
//         .modal-desc { color: #64748b; font-size: 14px; margin-bottom: 24px; }
        
//         .modal-btn-row { display: flex; gap: 12px; margin-top: 20px; }
//         .btn-cancel { flex: 1; height: 50px; background: #f1f5f9; border: none; border-radius: 14px; color: #475569; font-weight: 600; cursor: pointer; }
//         .btn-cancel:hover { background: #e2e8f0; color: #0f172a; }

//         .empty-placeholder { padding: 50px; text-align: center; color: #94a3b8; font-size: 15px; font-weight: 500; }
//       `}</style>

//       <div className="merchant-page">
        
//         {/* PREMIUM NAVIGATION */}
//         <nav className="premium-nav">
//           <div className="nav-brand">CountMyVisit</div>
//           <span className="badge" style={{ background: '#f1f5f9', color: '#475569', fontFamily: 'monospace' }}>MID: {MERCHANT_ID}</span>
//         </nav>

//         {/* TOP COMPONENT HEADER */}
//         <header className="top-header">
//           <div>
//             <div className="merchant-title">Subscription Management</div>
//             <div className="merchant-sub">Activate secure premium pipelines, unlock analytical tracking tools</div>
//           </div>
//           <div className="merchant-logo">S</div>
//         </header>

//         {/* NAVIGATION SEGMENTED TABS */}
//         <div className="tabs-container">
//           <button className={`tab-btn ${activeTab === "plans" ? "active" : ""}`} onClick={() => setActiveTab("plans")}>
//             Available Plans
//           </button>
//           <button className={`tab-btn ${activeTab === "history" ? "active" : ""}`} onClick={() => setActiveTab("history")}>
//             Billing History ({subscriptionHistory.length})
//           </button>
//         </div>

//         {/* WORKSPACE CONDITIONALS */}
//         {activeTab === "plans" ? (
//           <div className="plans-grid">
//             {availablePlans.map((plan) => {
//               const isSixMonth = plan.plan_name.toLowerCase().includes("6");
//               return (
//                 <div key={plan.id} className={`plan-card ${isSixMonth ? "popular" : ""}`}>
//                   {isSixMonth && <div className="popular-badge">Best Value</div>}
//                   <div>
//                     <div className="plan-name">{plan.plan_name}</div>
//                     <div className="plan-desc">{plan.description}</div>
//                     <div className="plan-price-box">
//                       <span className="plan-currency">₹</span>
//                       <span className="plan-price">{parseInt(plan.amount)}</span>
//                       <span className="plan-duration"> / {plan.duration_months} Month</span>
//                     </div>
//                   </div>
//                   <button className="action-btn" onClick={() => setSelectedPlan(plan)}>
//                     {isSixMonth ? "Upgrade to Pro" : "Renew Subscriptions"}
//                   </button>
//                 </div>
//               );
//             })}
//           </div>
//         ) : (
//           <div className="card-table-wrap">
//             <h2>Payment & Audit History</h2>
//             <p style={{ color: '#64748b', fontSize: '13.5px', marginBottom: '20px' }}>Historical active mapping loops for ledger reconciliation</p>
            
//             <div className="table-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Plan Description</th>
//                     <th>Transaction Cost</th>
//                     <th>Allocation Window</th>
//                     <th>Status Flag</th>
//                     <th>Horizon Delta</th>
//                     <th>Created At</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {subscriptionHistory.length === 0 ? (
//                     <tr>
//                       <td colSpan="6" className="empty-placeholder">No transaction logs mapped into local storage matrix.</td>
//                     </tr>
//                   ) : (
//                     subscriptionHistory.map((log) => (
//                       <tr key={log.id}>
//                         <td style={{ fontWeight: '700', color: '#0f172a' }}>{log.plan_name}</td>
//                         <td style={{ fontWeight: '600', color: '#0f172a' }}>₹{log.amount}</td>
//                         <td style={{ fontSize: '13px', color: '#475569' }}>
//                           {log.start_date} <span style={{ color: '#94a3b8' }}>to</span> {log.end_date}
//                         </td>
//                         <td>
//                           <span className={`badge ${log.status === "active" ? "badge-active" : "badge-expired"}`}>
//                             {log.status}
//                           </span>
//                         </td>
//                         <td style={{ fontWeight: '700', color: '#ff8c42', fontFamily: 'monospace' }}>
//                           {log.days_left} Days Left
//                         </td>
//                         <td style={{ color: '#94a3b8', fontSize: '13px' }}>{log.created_at}</td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {/* RAZORPAY PAYMENT CONFIRMATION GATEWAY MODAL */}
//         {selectedPlan && (
//           <div className="modal-overlay">
//             <div className="modal-card">
//               <div className="modal-title">Confirm Secure Purchase</div>
//               <div className="modal-desc">
//                 You are initiating connection parameters to sub-license the <strong>{selectedPlan.plan_name}</strong>.
//               </div>
              
//               <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '14px', marginBottom: '24px', textAlign: 'left', border: '1px solid #e2e8f0' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '14px' }}>
//                   <span style={{ color: '#64748b' }}>Plan Payload:</span>
//                   <span style={{ fontWeight: '700', marginLeft: 'auto' }}>{selectedPlan.plan_name}</span>
//                 </div>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px', paddingTop: '6px', borderTop: '1px dashed #cbd5e1' }}>
//                   <span style={{ color: '#0f172a', fontWeight: '600' }}>Payable Amount:</span>
//                   <span style={{ fontWeight: '800', color: '#ff8c42', marginLeft: 'auto' }}>₹{selectedPlan.amount}</span>
//                 </div>
//               </div>

//               <div className="modal-btn-row">
//                 <button className="btn-cancel" disabled={isProcessing} onClick={() => setSelectedPlan(null)}>
//                   Abort
//                 </button>
//                 <button className="action-btn" style={{ flex: 1 }} disabled={isProcessing} onClick={() => handleActivatePlan(selectedPlan)}>
//                   {isProcessing ? "Opening Razorpay..." : "Pay with Razorpay"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// }


import React, { useState, useEffect } from "react";

export default function MerchantSubscriptionPanel() {
  // Extract Dynamic Merchant ID safely
  const getDynamicMerchantId = () => {
    try {
      const savedDataString = localStorage.getItem("userData");
      if (savedDataString) {
        const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
        const parsed = JSON.parse(cleanDataStr);
        if (parsed?.merchant?.user_id) {
          return parsed.merchant.user_id;
        }
      }
    } catch (e) {
      console.error("Error reading initial userData:", e);
    }
    return "CMVA1AE47572E";
  };

  const MERCHANT_ID = getDynamicMerchantId();

  // Navigation & Screen Control States
  const [activeTab, setActiveTab] = useState("plans"); // 'plans' or 'history'
  const [loading, setLoading] = useState(true);
  
  // Data States
  const [availablePlans, setAvailablePlans] = useState([]);
  const [subscriptionHistory, setSubscriptionHistory] = useState([]);
  
  // Checkout & Razorpay Ready States
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const cleanAndParseJson = (text) => {
    const cleanString = text.replace("DATABASE CONNECTED", "").trim();
    return JSON.parse(cleanString);
  };

  // 1. Fetch Available Subscription Plans
  const fetchAvailablePlans = async () => {
    try {
      const formdata = new FormData();
      formdata.append("plan_name", "1 Month Plan");
      formdata.append("amount", "199");
      formdata.append("description", "Unlimited Scans + Analytics");
      formdata.append("duration_months", "1");

      const response = await fetch("https://countmyvisit.com/Apis/subscription_plans.php", {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const resText = await response.text();
      const data = cleanAndParseJson(resText);
      if (data.success) {
        setAvailablePlans(data.plans || []);
      }
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
    }
  };

  // 2. Fetch Merchant Subscription History
  const fetchSubscriptionHistory = async () => {
    try {
      const formdata = new FormData();
      formdata.append("duration_months", "6");
      formdata.append("plan_id", "3");
      formdata.append("merchant_id", MERCHANT_ID);

      const response = await fetch("https://countmyvisit.com/Apis/subscription_history.php", {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const resText = await response.text();
      const data = cleanAndParseJson(resText);
      if (data.success) {
        setSubscriptionHistory(data.history || []);
      }
    } catch (error) {
      console.error("Error fetching subscription history:", error);
    }
  };

  // 3. Handle Order Creation and Razorpay Initiation Lifecycle
  const handleActivatePlan = async (plan) => {
    try {
      setIsProcessing(true);

      const formdata = new FormData();
      formdata.append("merchant_id", MERCHANT_ID);
      formdata.append("plan_id", plan.id);
      formdata.append("plan_name", plan.plan_name);
      formdata.append("amount", parseFloat(plan.amount).toFixed(0));
      formdata.append("description", plan.description);
      formdata.append("duration_months", plan.duration_months);

      const response = await fetch("https://countmyvisit.com/Apis/create_order.php", {
        method: "POST",
        body: formdata
      });

      const txt = await response.text();
      const orderData = cleanAndParseJson(txt);

      if (!orderData.success) {
        alert(orderData.message || "Order creation failure.");
        setIsProcessing(false);
        return;
      }

      const options = {
        key: "rzp_test_T3qnCkPeAhSP0g",
        amount: orderData.amount_in_paise || orderData.amount * 100,
        currency: orderData.currency || "INR",
        name: "Count My Visit",
        description: plan.plan_name,
        order_id: orderData.razorpay_order_id, // Mapped perfectly from your API response
        handler: async function (paymentResponse) {
          try {
            const verifyData = new FormData();
            verifyData.append("razorpay_payment_id", paymentResponse.razorpay_payment_id);
            verifyData.append("razorpay_order_id", paymentResponse.razorpay_order_id);
            verifyData.append("razorpay_signature", paymentResponse.razorpay_signature);
            verifyData.append("merchant_id", MERCHANT_ID);

            const verifyResponse = await fetch("https://countmyvisit.com/Apis/verify_payment.php", {
              method: "POST",
              body: verifyData
            });

            const verifyText = await verifyResponse.text();
            const verifyResult = cleanAndParseJson(verifyText);

            if (verifyResult.success) {
              alert("Subscription Activated Successfully!");
              setSelectedPlan(null);
              fetchSubscriptionHistory();
              setActiveTab("history");
            } else {
              alert(verifyResult.message || "Payment verification failed.");
            }
          } catch (err) {
            console.error("Verification system error:", err);
            alert("Error running confirmation system.");
          }
        },
        theme: {
          color: "#ff8c42"
        },
        modal: {
          ondismiss: function () {
            setIsProcessing(false);
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (error) {
      console.error("Order processing loop failed:", error);
      alert("Payment Framework Initialization Failure");
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    const loadSubscriptionData = async () => {
      setLoading(true);
      await Promise.all([fetchAvailablePlans(), fetchSubscriptionHistory()]);
      setLoading(false);
    };
    loadSubscriptionData();
  }, [MERCHANT_ID]);

  if (loading) {
    return (
      <div className="loader-container">
        <style>{`
          .loader-container { display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100vh; background: #f8fafc; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
          .spinner { width: 44px; height: 44px; border: 3px solid rgba(255, 140, 66, 0.1); border-left-color: #ff8c42; border-radius: 50%; animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite; margin-bottom: 16px; }
          .loader-text { font-weight: 600; font-size: 14px; color: #64748b; letter-spacing: 0.5px; }
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
        <div className="spinner"></div>
        <p className="loader-text">FETCHING BILLING SCHEMATICS...</p>
      </div>
    );
  }

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
        body { background: #f8fafc; color: #1e293b; }
        .merchant-page { min-height: 100vh; padding: 32px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); position: relative; }
        
        /* Premium Dynamic Navigation Bar */
        .premium-nav {
          display: flex; justify-content: space-between; align-items: center; background: #ffffff; padding: 16px 32px; border-radius: 20px;
          box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05); margin-bottom: 30px; border: 1px solid rgba(255, 255, 255, 0.8);
        }
        .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        
        /* Segmented Tabs Layout */
        .tabs-container { display: flex; gap: 12px; background: #e2e8f0; padding: 6px; border-radius: 14px; margin-bottom: 30px; max-width: 400px; }
        .tab-btn { flex: 1; padding: 10px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; color: #475569; background: transparent; }
        .tab-btn.active { background: #ffffff; color: #0f172a; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }

        /* Dashboard Top Info Card */
        .top-header {
          background: #ffffff; padding: 30px; border-radius: 24px; box-shadow: 0 10px 30px rgba(0,0,0,0.02);
          display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; border-left: 6px solid #ff8c42;
        }
        .merchant-title { font-size: 28px; font-weight: 800; color: #0f172a; }
        .merchant-sub { font-size: 14px; color: #64748b; margin-top: 4px; }
        .merchant-logo { width: 60px; height: 60px; border-radius: 18px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 22px; font-weight: 700; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }

        /* Plans Grid Configuration */
        .plans-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; }
        .plan-card { background: white; border-radius: 24px; padding: 32px; border: 1px solid #e2e8f0; position: relative; display: flex; flex-direction: column; justify-content: space-between; transition: transform 0.2s, box-shadow 0.2s; }
        .plan-card:hover { transform: translateY(-4px); box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06); }
        .plan-card.popular { border-color: #ff8c42; box-shadow: 0 10px 25px rgba(255, 140, 66, 0.08); }
        .popular-badge { position: absolute; top: -12px; right: 24px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 11px; font-weight: 700; padding: 4px 12px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px; }
        
        .plan-name { font-size: 20px; font-weight: 800; color: #0f172a; margin-bottom: 8px; }
        .plan-desc { color: #64748b; font-size: 14px; margin-bottom: 24px; min-height: 40px; }
        .plan-price-box { margin-bottom: 28px; }
        .plan-currency { font-size: 20px; font-weight: 700; color: #0f172a; vertical-align: top; margin-right: 2px; }
        .plan-price { font-size: 42px; font-weight: 800; color: #0f172a; letter-spacing: -1px; }
        .plan-duration { color: #64748b; font-size: 14px; font-weight: 500; }

        .action-btn { width: 100%; height: 50px; border: none; border-radius: 14px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); }
        .action-btn:hover { opacity: 0.95; transform: translateY(-1px); }
        .action-btn:disabled { background: #cbd5e1; color: #94a3b8; cursor: not-allowed; box-shadow: none; }
        
        /* Tables Core Billing Engine */
        .card-table-wrap { background: white; border-radius: 24px; padding: 28px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0; }
        .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; }
        table { width: 100%; border-collapse: collapse; min-width: 850px; text-align: left; }
        th { background: #f8fafc; color: #475569; padding: 16px 24px; font-size: 13px; font-weight: 700; border-bottom: 2px solid #e2e8f0; text-transform: uppercase; letter-spacing: 0.5px; }
        td { padding: 18px 24px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
        tr:hover { background: #f8fafc; }
        
        /* Badges Engine */
        .badge { display: inline-block; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase; }
        .badge-active { background: #ecfdf5; color: #047857; border: 1px solid #a7f3d0; }
        .badge-expired { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }
        
        /* Modal Overlay for Payment Initialization */
        .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(8px); display: flex; justify-content: center; align-items: center; z-index: 1000; padding: 24px; }
        .modal-card { background: white; border-radius: 24px; max-width: 440px; width: 100%; padding: 32px; border: 1px solid #e2e8f0; box-shadow: 0 20px 40px rgba(0,0,0,0.1); text-align: center; }
        .modal-title { font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 8px; }
        .modal-desc { color: #64748b; font-size: 14px; margin-bottom: 24px; }
        
        .modal-btn-row { display: flex; gap: 12px; margin-top: 20px; }
        .btn-cancel { flex: 1; height: 50px; background: #f1f5f9; border: none; border-radius: 14px; color: #475569; font-weight: 600; cursor: pointer; }
        .btn-cancel:hover { background: #e2e8f0; color: #0f172a; }

        .empty-placeholder { padding: 50px; text-align: center; color: #94a3b8; font-size: 15px; font-weight: 500; }
      `}</style>

      <div className="merchant-page">
        
        {/* PREMIUM NAVIGATION */}
        <nav className="premium-nav">
          <div className="nav-brand">CountMyVisit</div>
          <span className="badge" style={{ background: '#f1f5f9', color: '#475569', fontFamily: 'monospace' }}>MID: {MERCHANT_ID}</span>
        </nav>

        {/* TOP COMPONENT HEADER */}
        <header className="top-header">
          <div>
            <div className="merchant-title">Subscription Management</div>
            <div className="merchant-sub">Activate secure premium pipelines, unlock analytical tracking tools</div>
          </div>
          <div className="merchant-logo">S</div>
        </header>

        {/* NAVIGATION SEGMENTED TABS */}
        <div className="tabs-container">
          <button className={`tab-btn ${activeTab === "plans" ? "active" : ""}`} onClick={() => setActiveTab("plans")}>
            Available Plans
          </button>
          <button className={`tab-btn ${activeTab === "history" ? "active" : ""}`} onClick={() => setActiveTab("history")}>
            Billing History ({subscriptionHistory.length})
          </button>
        </div>

        {/* WORKSPACE CONDITIONALS */}
        {activeTab === "plans" ? (
          <div className="plans-grid">
            {availablePlans.map((plan) => {
              const isSixMonth = plan.plan_name.toLowerCase().includes("6");
              return (
                <div key={plan.id} className={`plan-card ${isSixMonth ? "popular" : ""}`}>
                  {isSixMonth && <div className="popular-badge">Best Value</div>}
                  <div>
                    <div className="plan-name">{plan.plan_name}</div>
                    <div className="plan-desc">{plan.description}</div>
                    <div className="plan-price-box">
                      <span className="plan-currency">₹</span>
                      <span className="plan-price">{parseInt(plan.amount)}</span>
                      <span className="plan-duration"> / {plan.duration_months} Month</span>
                    </div>
                  </div>
                  <button className="action-btn" onClick={() => setSelectedPlan(plan)}>
                    {isSixMonth ? "Upgrade to Pro" : "Renew Subscriptions"}
                  </button>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="card-table-wrap">
            <h2>Payment & Audit History</h2>
            <p style={{ color: '#64748b', fontSize: '13.5px', marginBottom: '20px' }}>Historical active mapping loops for ledger reconciliation</p>
            
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Plan Description</th>
                    <th>Transaction Cost</th>
                    <th>Allocation Window</th>
                    <th>Status Flag</th>
                    <th>Horizon Delta</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {subscriptionHistory.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="empty-placeholder">No transaction logs mapped into local storage matrix.</td>
                    </tr>
                  ) : (
                    subscriptionHistory.map((log) => (
                      <tr key={log.id}>
                        <td style={{ fontWeight: '700', color: '#0f172a' }}>{log.plan_name}</td>
                        <td style={{ fontWeight: '600', color: '#0f172a' }}>₹{log.amount}</td>
                        <td style={{ fontSize: '13px', color: '#475569' }}>
                          {log.start_date} <span style={{ color: '#94a3b8' }}>to</span> {log.end_date}
                        </td>
                        <td>
                          <span className={`badge ${log.status === "active" ? "badge-active" : "badge-expired"}`}>
                            {log.status}
                          </span>
                        </td>
                        <td style={{ fontWeight: '700', color: '#ff8c42', fontFamily: 'monospace' }}>
                          {log.days_left} Days Left
                        </td>
                        <td style={{ color: '#94a3b8', fontSize: '13px' }}>{log.created_at}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* RAZORPAY PAYMENT CONFIRMATION GATEWAY MODAL */}
        {selectedPlan && (
          <div className="modal-overlay">
            <div className="modal-card">
              <div className="modal-title">Confirm Secure Purchase</div>
              <div className="modal-desc">
                You are initiating connection parameters to sub-license the <strong>{selectedPlan.plan_name}</strong>.
              </div>
              
              <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '14px', marginBottom: '24px', textAlign: 'left', border: '1px solid #e2e8f0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '14px' }}>
                  <span style={{ color: '#64748b' }}>Plan Payload:</span>
                  <span style={{ fontWeight: '700', marginLeft: 'auto' }}>{selectedPlan.plan_name}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px', paddingTop: '6px', borderTop: '1px dashed #cbd5e1' }}>
                  <span style={{ color: '#0f172a', fontWeight: '600' }}>Payable Amount:</span>
                  <span style={{ fontWeight: '800', color: '#ff8c42', marginLeft: 'auto' }}>₹{selectedPlan.amount}</span>
                </div>
              </div>

              <div className="modal-btn-row">
                <button className="btn-cancel" disabled={isProcessing} onClick={() => setSelectedPlan(null)}>
                  Abort
                </button>
                <button className="action-btn" style={{ flex: 1 }} disabled={isProcessing} onClick={() => handleActivatePlan(selectedPlan)}>
                  {isProcessing ? "Opening Razorpay..." : "Pay with Razorpay"}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}